const registrationWizard = {
  state: {
    currentStep: 1,
  },
  mutations: {
    setCurrentStep(state, currentStep) {
      state.currentStep = currentStep;
    },
  },
  actions: {
    setCurrentStep({ commit }, currentStep) {
      commit('setCurrentStep', currentStep);
    },
  },
  getters: {
    currentStep: (state) => state.currentStep,
  },
};

export default registrationWizard;
